import showAgentContractDictionary from '@features/show-agent-contract/i18n/ru/show-agent-contract.dic.json';

export const showAgentContract = {
  SHOW_AGENT_CONTRACT: showAgentContractDictionary,
};

export const showAgentContractNamespaces = ['SHOW_AGENT_CONTRACT'];
